import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  pillBase: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFFFFF',
    border: 'solid 1px',
    borderRadius: '15px',
    padding: '2px 3px 2px 8px',
    height: 'min-content',
    minHeight: '17px',
    minWidth: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
  },
  points: {
    marginRight: '2px',
  },
}));
